import type {
  CommonResponseCollectionStudentLearningWrongStepKeyValueResponse,
  CommonResponseStudentLearningConceptStepResponse,
  GetConceptStepByStudentWorksheetIdParams,
  GetWrongStepByStudentWorksheetIdParams,
  LearningTimeSaveData,
  LearningTimeSaveParams,
} from '~/api-spec/__generated__/main'
import { httpClient, type RequestMeta } from '~/http/client'

import { adaptConceptLearningStep, adaptWrongLearningSteps } from './adapters'
import type { ConceptLearningStep, WrongLearningStep } from './schemas'

export type ConceptLearningStepParams = GetConceptStepByStudentWorksheetIdParams
export type WrongLearningStepsParams = GetWrongStepByStudentWorksheetIdParams

export const getConceptLearningStep = async (
  params: ConceptLearningStepParams,
  meta?: RequestMeta,
): Promise<ConceptLearningStep> => {
  const body = await httpClient().get<CommonResponseStudentLearningConceptStepResponse>(
    '/student-learning/self-learning/steps/concept',
    { params, meta },
  )
  return adaptConceptLearningStep(body.data)
}

// 본문이 없으면 빈 목록이 아니라 조회 실패다. 빈 목록으로 읽으면 화면이 "오답 유형학습 없음" 으로 보이고
// 학습 절차까지 그렇게 저장되므로 폴백하지 않고 undefined 를 그대로 돌려준다.
export const getWrongLearningSteps = async (
  params: WrongLearningStepsParams,
  meta?: RequestMeta,
): Promise<WrongLearningStep[] | undefined> => {
  const body =
    await httpClient().get<CommonResponseCollectionStudentLearningWrongStepKeyValueResponse>(
      '/student-learning/self-learning/steps/wrong',
      { params, meta },
    )
  return adaptWrongLearningSteps(body.data)
}

/** 학생이 학습한 시간(분)을 쌓는다. 앱이 학습 화면에 머문 시간을 주기적으로 보낸다 */
export const recordLearningTime = async (
  minute: LearningTimeSaveParams['minute'],
  meta?: RequestMeta,
): Promise<void> => {
  await httpClient().post<LearningTimeSaveData>('/student-learning/time', undefined, {
    params: { minute },
    meta,
  })
}
